import React from "react";
import { cn } from "@/lib/utils";

/**
 * Editorial KPI Card — large serif number + monospace meta.
 * tone: 'default' (eucalyptus accent), 'warm' (terracota), 'ochre', 'neutral'.
 */
export function KpiCard({ label, value, meta, hint, tone = "default", icon: Icon, className, testId }) {
  const accent = {
    default: "text-primary",
    warm:    "text-[hsl(var(--brand-warm))]",
    ochre:   "text-[hsl(var(--brand-ochre))]",
    neutral: "text-foreground",
  }[tone] || "text-primary";

  return (
    <div
      data-testid={testId || "dashboard-kpi-card"}
      className={cn(
        "group rounded-[var(--radius)] border border-border bg-card p-4 sm:p-5",
        "shadow-paper hover:shadow-paper-hover transition-[box-shadow,border-color] duration-200",
        className
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            {Icon ? <Icon size={13} className="text-muted-foreground" /> : null}
            <p className="text-[10.5px] font-heading uppercase tracking-[0.1em] text-muted-foreground">
              {label}
            </p>
          </div>
          <p className={cn(
            "mt-2 font-editorial tabular-nums tracking-tight leading-none",
            "text-[44px] sm:text-[52px]",
            accent
          )}>
            {value}
          </p>
          {meta && (
            <p className="mt-2 text-[10.5px] font-mono text-muted-foreground tracking-tight">{meta}</p>
          )}
          {hint && !meta && (
            <p className="mt-2 text-xs text-muted-foreground">{hint}</p>
          )}
        </div>
      </div>
    </div>
  );
}
